import { Settings, Bell, FileText, UserCog, Search, MessageSquare, Play, Share2, Power, Sliders, RotateCcw } from 'lucide-react';

export const dashboardItems = [
  {
    id: 'system-config',
    icon: Settings,
    title: 'System Configuration',
    description: 'Configuring General Parameters'
  },
  {
    id: 'alarm-config',
    icon: Bell,
    title: 'Alarm Configuration',
    description: 'to configure alarm schedule, notifications & other parameters.'
  },
  {
    id: 'report-config',
    icon: FileText,
    title: 'Report Configuration',
    description: 'Management of report and configuration of user defined reports.'
  },
  {
    id: 'user-management',
    icon: UserCog,
    title: 'User Management',
    description: 'To add, delete user and assigning the permissions.'
  },
  {
    id: 'log-search',
    icon: Search,
    title: 'Log Search',
    description: 'Searching, viewing & backing up local and remote based logs.'
  },
  {
    id: 'message-status',
    icon: MessageSquare,
    title: 'Message Que Status',
    description: 'Check status of message sent from System.'
  }
];

export const maintenanceItems = [
  {
    id: 'self-test',
    icon: Play,
    title: 'SELF TEST',
    description: 'Run a self test to check status of device connected to the system.'
  },
  {
    id: 'share-screen',
    icon: Share2,
    title: 'SHARE SCREEN',
    description: 'Take help of system experts by sharing your live screen.'
  },
  {
    id: 'video-player',
    icon: Play,
    title: 'Video Player',
    description: 'Access and play recorded videos in system embedded video player.'
  },
  {
    id: 'system-restart',
    icon: Power,
    title: 'SYSTEM RESTART',
    description: 'Quick restart the system.'
  },
  {
    id: 'system-calibration',
    icon: Sliders,
    title: 'System calibration',
    description: 'For quick and periodic calibration of the system to ensure accuracy, precision and repeatability.'
  },
  {
    id: 'restore-update',
    icon: RotateCcw,
    title: 'Restore and update',
    description: 'For quick and periodic updates of the system, also system can be restored to previous configuration.'
  }
];